<div class="mt-3 row">
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 text-sm-center text-md-center text-lg-center text-xl-end text-xxl-end">
    <app-so-button-group-radio id="{{idGroup}}_filters" class="" [data]="filters"></app-so-button-group-radio>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 text-sm-center text-md-center text-lg-center text-xl-start text-xl-start">
    <app-so-button-group-radio id="{{idGroup}}_filters_tipe" [data]="filters_tipe" ></app-so-button-group-radio>
  </div>
</div>
